import { Link, useLocation } from "react-router-dom";

const MenuBar = () => {
  const { pathname } = useLocation();
  const MENU_ITEMS = [
    { label: "TRANG CHỦ", path: "/trang-chu" },
    { label: "DỊCH VỤ", path: "/dich-vu" },
    // { label: "THÀNH PHẨM", path: "/thanh-pham" },
    // { label: "LIÊN HỆ", path: "/lien-he" },
  ];

  return (
    <div className="the-header-menu-bar">
      {MENU_ITEMS.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`menu-link ${
            pathname.startsWith(item.path) ? "active" : ""
          }`}
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default MenuBar;
